import dayjs from "dayjs";

export const WEEK_COLORS = ["#df9e44", "#cd683e"];

export const GAP_LINE_COLOR = "#df9e44";

export const formatCurrency = (val) => {
  if (val == null) return "$0";
  if (Math.abs(val) >= 1000) return `$${(val / 1000).toFixed(0)}K`;
  return `$${val.toFixed(0)}`;
};

export const buildWeekColors = (days) => {
  let weekIdx = -1;
  return days.map((d, i) => {
    const dow = dayjs(d).day();
    if (i === 0 || dow === 1) weekIdx += 1;
    return WEEK_COLORS[weekIdx % WEEK_COLORS.length];
  });
};

export const buildDataset = (department, days, goal) => {
  const today = dayjs().format("YYYY-MM-DD");
  let cum = 0;
  let passedToday = false;
  return days.map((day, idx) => {
    const revenue = department.daily[day] || 0;
    if (passedToday || !idx) {
      return { day, revenue, gap: 0 };
    }
    cum += revenue - (goal || 0);
    const gap = cum;
    if (day >= today) passedToday = true;
    return { day, revenue, gap };
  });
};
